import { createChildListPrintContainer } from 'factories/ChildListPrint'
import Component from 'components/ProcessSetupSheet/Print/AssociatedProducts'

export default createChildListPrintContainer()(Component)
